import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default {
  init() {

    gsap.config({ nullTargetWarn: false });

    $('.smooth').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top - 90}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    setTimeout(function() {
      $('.ribbon').addClass('visible');
    }, 1000);

    $('.menu-icon').on('click', function(event) {
      $('.top-bar').toggleClass('open');
      setTimeout(function() {
        $('.title-bar').toggleClass('mob-open');
      }, 200);
      event.preventDefault();
    });

    $('.test-wrap').slick({
      arrows: true,
      infinite: false,
    });

    $('.slide-wrap').on('init', function(event, slick) {
      $('.slide-nav li:first-child').addClass('slide-is-active');
    });

    $('.slide-wrap').slick({
      fade: true,
      arrows: true,
      nextArrow:"<button type='button' class='slick-next pull-right r-only'><i class='far fa-chevron-right'></i></button>",
      prevArrow:"<button type='button' class='slick-prev pull-right l-only'><i class='far fa-chevron-left'></i></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    $('.slide-wrap').on('afterChange', function(event, slick, currentSlide, nextSlide) {
      let i = currentSlide + 1;
      switch (i) {
        case 1:
        $('.skew-1').addClass('blue');
        $('.skew-2').addClass('blue');
        $('.skew-1').removeClass('purple');
        $('.skew-2').removeClass('purple');
        $('.skew-1').removeClass('green');
        $('.skew-2').removeClass('green');
        $('.slick-prev').css('visibility', 'hidden');
        $('.slick-next').css('visibility', 'visible');
        break;
        case 2:
        $('.skew-1').addClass('purple');
        $('.skew-2').addClass('purple');
        $('.skew-1').removeClass('blue');
        $('.skew-2').removeClass('blue');
        $('.skew-1').removeClass('green');
        $('.skew-2').removeClass('green');
        $('.slick-prev.l-only').css('visibility', 'visible');
        $('.slick-next.r-only').css('visibility', 'visible');
        break;
        case 3:
        $('.skew-1').addClass('green');
        $('.skew-2').addClass('green');
        $('.skew-1').removeClass('blue');
        $('.skew-2').removeClass('blue');
        $('.skew-1').removeClass('purple');
        $('.skew-2').removeClass('purple');
        $('.slick-prev.l-only').css('visibility', 'visible');
        $('.slick-next.r-only').css('visibility', 'hidden');
        break;
      }
    });

    $('.feed').slick({
      fade: true,
      arrows: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
    });

    $('.meet-team-scroll').slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      ],
    });

    $('.circle-slides').slick({
      centerMode: true,
      slidesToShow: 3,
      dots: true,
      arrows: true,
      speed: 2,
      autoplay: true,
      autoplaySpeed: 4000,
      initialSlide: 3,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      ],
    });

    $('.stat-list').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: true,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $('.fade-slider').slick({
      fade: true,
      arrows: true,
      dots: false,
      autoPlay: true,
      autoplaySpeed: 4000,
      nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",
      prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
    });

    $('li[data-slide]').on('click', function(event) {
      var slideno = $(this).data('slide');
      $('.slide-wrap').slick('slickGoTo', slideno - 1);
      $(this).addClass('slide-is-active');
      $(this).siblings('li').removeClass('slide-is-active');
      event.preventDefault();
    });

    $('.r-only').on('click', function() {
      let current = $('.slide-wrap').slick('slickCurrentSlide') + 1;
      $('.slide-nav li[data-slide = '+current+']').addClass('slide-is-active');
      $('.slide-nav li[data-slide = '+current+']').siblings().removeClass('slide-is-active');
    });

    $('.l-only').on('click', function() {
      let current = $('.slide-wrap').slick('slickCurrentSlide') + 1;
      $('.slide-nav li[data-slide = '+current+']').addClass('slide-is-active');
      $('.slide-nav li[data-slide = '+current+']').siblings().removeClass('slide-is-active');
    });

    $('.team h4').on('click', function(event) {
      $(this).next().toggleClass('open');
      event.preventDefault();
    });

    $('.read-full').on('click', function(event) {
      $(this).prev().slideToggle(function() {
        if (!$('.education').hasClass('show')) {
          $('.education').addClass('show');
        } else {
          $('.education').removeClass('show');
        }
      });
      event.preventDefault();
    });

    $('.singlecompslider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        variableWidth: true,
        nextArrow:"<button type='button' class='slick-next'></button>",
        prevArrow:"<button type='button' class='slick-prev'></button>",
      });


    // Marquee Text

    let marqText = document.querySelector('.marquee h1')
    let scroller = document.querySelector('.scroll-down')
    gsap.to(marqText, {opacity: 1, duration: 1.5, y: 0, ease: 'power4.out'})
    gsap.to(scroller, {opacity: 1, duration: 1.5, y: 0, ease: 'back.inOut(1.5)'}, '<')


    // Scroll Animations

    let skew = gsap.timeline({
      scrollTrigger: {
        trigger: '.carousel',
        start: 'top center',
      },
    })
    skew.to('.skew-1', {y: 0, x: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
    .to('.skew-2', {y: 0, x: 0, opacity: 1, duration: 1.5, ease: 'power4.out' }, '-=1.5')
    .to('.slide-nav', {y: 0, opacity: 1, duration: .5, ease: 'power4.out' }, '-=0.5')
    .to('.button', {y: 0, opacity: 1, duration: .5, ease: 'power4.out' }, '-=0.25')
    .to('.slide-wrap', {y: 0, opacity: 1, duration: .5, ease: 'power4.out' }, '-=0.25')


     // Image Banner Animation
     let imgArray = gsap.utils.toArray('.img-bar');
     imgArray.forEach((img, i) => {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top center',
        },
      })
      tl.to(img.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(img.querySelector('.button'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=1')
    });

     let tw = gsap.timeline({
      scrollTrigger: {
        trigger: '.team-wrp',
        start: 'top center',
      },
    })
     tw.to('.team-wrp .img', {opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}})
     .to('.team-wrp .decoration', {bottom: '13vw', opacity: 0.6, duration: 1.5, ease: 'back.out(1.3)'}, '-=1.5')
     .to('.team-wrp h2', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to('.team-wrp .button-wrp', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')

     // Team Archive 

     const greenHeadline = document.querySelector('.green h1');
     const greenImgs = document.querySelectorAll('.green .img')
     const greenSubHealdine = document.querySelector('.green h3');
     const blueBg = document.querySelector('.blue');
     const blueHeadline = document.querySelector('.blue h1');
     const blueImgs = document.querySelectorAll('.blue .img')
     const blueSubHealdine = document.querySelector('.blue h3');
     const purpleBg = document.querySelector('.purple');
     const purpleHeadline = document.querySelector('.purple h1');
     const purpleImgs = document.querySelectorAll('.purple .img')
     const purpleSubHealdine = document.querySelector('.purple h3');

     let green = gsap.timeline({
      scrollTrigger: {
        trigger: '.green',
        start: 'top center',
      },
    })
     green.to(greenHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(greenSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(greenImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')


     let blue = gsap.timeline({
      scrollTrigger: {
        trigger: '.blue',
        start: 'top center',
      },
    })
     blue.to(blueBg, {backgroundColor: '#0079ea', duration: 1.5, ease: 'power4.out'})
     .to(blueHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(blueSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(blueImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')

     let purple = gsap.timeline({
      scrollTrigger: {
        trigger: '.purple',
        start: 'top center',
      },
    })
     purple.to(purpleBg, {backgroundColor: '#a44ff5', duration: 1.5, ease: 'power4.out'})
     .to(purpleHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(purpleSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(purpleImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')


     // Stats

     const statHeadline = document.querySelector('.stats h2');
     const statText = document.querySelectorAll('.stats p')
     const statSlider = document.querySelector('.stats .stat-list');

     let stats = gsap.timeline({
      scrollTrigger: {
        trigger: '.stats',
        start: 'top center',
      },
    })
     stats.to(statHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(statText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(statSlider, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')


     // CC Circles

     const ccHeadline = document.querySelector('.carousel-circles h2')
     const ccText = document.querySelector('.carousel-circles p')
     const ccTextSpOne = new SplitText('.carousel-circles h2 span.one', {type: 'chars'})
     const ccTextSpTwo = new SplitText('.carousel-circles h2 span.two', {type: 'chars'})
     const ccSlides = document.querySelector('.circle-slides')

     let cCircles = gsap.timeline({
      scrollTrigger: {
        trigger: '.carousel-circles',
        start: 'top center',
      },
    })
     cCircles.to(ccHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(ccText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(ccTextSpOne.chars, {color: '#f76905', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(ccTextSpTwo.chars, {color: '#f76905', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(ccSlides, {opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')

     // Cols Split

     const colsHeadline = document.querySelector('.callout-cols h3');
     const colsArrow = document.querySelector('.callout-cols .right-arrow');
     const colsSubHealdine = document.querySelector('.callout-cols p');

     let cols = gsap.timeline({
      scrollTrigger: {
        trigger: '.callout-cols',
        start: 'top center',
      },
    })
     cols.to(colsHeadline, {x: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)'})
     .to(colsArrow, {x: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)'}, '-=1')
     .to(colsSubHealdine, {x: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)'}, '-=1')


     // Accordion Comp

     const accHeadline = document.querySelector('.accordion-comp h2')
     const accSub = document.querySelector('.accordion-comp h3')
     const accList = document.querySelector('.accordion-comp .accordion')
     const accHighlight = new SplitText('.accordion-comp .highlight', {type: 'chars'})

     let accComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.accordion-comp',
        start: 'top center',
      },
    })
     accComp.to(accSub, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(accList, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(accHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(accHighlight.chars, {color: '#0079ea', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')


     // Arrow

     const arrowPurple = document.querySelector('.arrow-banner .purple')
     const arrowLogo = document.querySelector('.arrow-banner .purple img')
     const arrowText = document.querySelectorAll('.arrow-banner .ol')

     let arrowComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.arrow-banner',
        start: 'top center',
      },
    })
     arrowComp.to(arrowPurple, {x: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.1)'})
     .to(arrowLogo, {opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=0.2')
     .to(arrowText, {opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')

     // Buckets

     const bucketsHeadline = document.querySelector('.buckets h2')
     const bucketsHighlight1 = new SplitText('.buckets h2 .highlight1', {type: 'chars'})
     const bucketsHighlight2 = new SplitText('.buckets h2 .highlight2', {type: 'chars'})
     const bucketsHighlight3 = new SplitText('.buckets h2 .highlight3', {type: 'chars'})
     const bucketsText = document.querySelector('.buckets .div-text')
     const bucketsLine1 = document.querySelector('.buckets .inner.l')
     const bucketsLine2 = document.querySelector('.buckets .inner.r')
     const bucket = document.querySelectorAll('.buckets .bucket')

     let buckComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.buckets',
        start: 'top center',
      },
    })
     buckComp.to(bucketsHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(bucketsHighlight1.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1.5')
     .to(bucketsHighlight2.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1.5')
     .to(bucketsHighlight3.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1.5')
     .to(bucketsText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(bucketsLine1, {width: '100%', duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(bucketsLine2, {width: '100%', duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(bucket, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.5}}, '-=1')


     // Split Text

     const splitLeft = document.querySelector('.split.text h2')
     const splitRight = document.querySelector('.split.text p')

     let splitText = gsap.timeline({
      scrollTrigger: {
        trigger: '.split.text',
        start: 'top center',
      },
    })
     splitText.to(splitLeft, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(splitRight, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')

     // Accordion

     const tabWrap = document.querySelector('.tab-wrap')

     let tabWrp = gsap.timeline({
      scrollTrigger: {
        trigger: '.tab-wrap',
        start: 'top center',
      },
    })
     tabWrp.to(tabWrap, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})


     $('.comp-tabs .tabs-title:first-of-type').addClass('is-active');
     $('.comp-tabs .tabs-title:first-of-type a').attr('aria-selected', 'true');
     $('.comp-tabs .tabs-panel:first-of-type').addClass('is-active');

   },
   finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js